(function() {
  'use strict';

  /* ===== v8: SINGLE-INIT GUARD =====
     Prevents stacking of setInterval / MutationObserver / document-level
     event listeners if Shopify's AJAX navigation re-executes this script. */
  if (window._qaV8Initialized) return;
  window._qaV8Initialized = true;

  var FEEDBACK_MS = 500;
  var CACHE = {};
  var IMG_CACHE = {};
  var IS_MOBILE = window.matchMedia('(hover: none) and (pointer: coarse)').matches;

  /* ===== v8: LOCALE PATH HELPER =====
     Prepends the active sub-folder locale (/de/, /fr/, etc.) to any
     root-relative path. Detects from window.location.pathname so it works
     for any locale OB adds in future without code changes.
     Safe on EN (no prefix): the regex only matches 2-letter ISO codes
     followed immediately by / or end-of-string, so /collections/... won't
     match. */
  function localePath(path) {
    var m = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)(\/|$)/i);
    if (!m) return path;
    return '/' + m[1] + path;
  }

  /* ===== HELPERS ===== */

  /* v8: fetch uses localePath so requests stay in the active locale context,
     preventing root-locale session cookies from being set mid-session. */
  function fetchProduct(handle) {
    if (CACHE[handle]) return Promise.resolve(CACHE[handle]);
    return fetch(localePath('/products/' + handle + '.js'))
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(p) { if (p) CACHE[handle] = p; return p; })
      .catch(function() { return null; });
  }

  function getSizes(product) {
    var opts = product.options || [];
    var idx = -1;
    for (var j = 0; j < opts.length; j++) {
      var n = (typeof opts[j] === 'string') ? opts[j] : (opts[j].name || '');
      if (n.toLowerCase() === 'size') { idx = j; break; }
    }
    if (idx === -1) return null;
    var sizes = [], seen = {};
    (product.variants || []).forEach(function(v) {
      var s = v['option' + (idx + 1)];
      if (s && !seen[s]) { seen[s] = true; sizes.push({ label: s, id: v.id, avail: v.available === true }); }
    });
    return sizes.length ? sizes : null;
  }

  function getActiveHandle(gi) {
    var checked = gi.querySelector('color-swatches input[type="radio"]:checked');
    if (checked) { var h = checked.getAttribute('data-handle'); if (h) return h; }
    var wrapper = gi.querySelector('.card-wrapper');
    return wrapper ? wrapper.getAttribute('data-handle') : null;
  }

  function getActiveColor(gi) {
    var checked = gi.querySelector('color-swatches input[type="radio"]:checked');
    if (!checked) return null;
    var label = document.querySelector('label[for="' + checked.id + '"]');
    if (!label) return null;
    var span = label.querySelector('span');
    if (!span) return null;
    var bg = window.getComputedStyle(span).backgroundColor;
    return { name: checked.value, bg: bg };
  }

  /* ===== ADD TO CART ===== */
  function addToCart(variantId) {
    var sectionIds = [];
    if (document.getElementById('shopify-section-cart-drawer')) sectionIds.push('cart-drawer');

    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (sectionIds.length) {
      body.sections = sectionIds.join(',');
      body.sections_url = window.location.pathname;
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
    .then(function(r) { if (!r.ok) throw new Error('fail'); return r.json(); })
    .then(function(data) {
      if (data && data.sections) {
        Object.keys(data.sections).forEach(function(sid) {
          var c = document.getElementById('shopify-section-' + sid);
          if (c) c.innerHTML = data.sections[sid];
        });
      }
      try {
        if (typeof window.shippingGiftCalculatorInit === 'function') {
          window.shippingGiftCalculatorInit();
        }
      } catch (e) {}
      function fireRenderedCart(target) {
        try { target.dispatchEvent(new CustomEvent('rendered-cart', { bubbles: true })); } catch (e) {}
      }
      fireRenderedCart(document);
      fireRenderedCart(window);
      var cd = document.querySelector('cart-drawer');
      if (cd) fireRenderedCart(cd);
      var cc = document.querySelector('.cart-countdown');
      if (cc) fireRenderedCart(cc);
      document.dispatchEvent(new CustomEvent('cart:updated'));
      return true;
    })
    .catch(function() { return false; });
  }

  /* Populate sheet price */
  function populateSheetPrice(gi, product, sourceEl) {
    var target = document.getElementById('qaSheetPrice');
    var priceEl = sourceEl || (gi ? (gi.querySelector('.price') || gi.querySelector('[class*="price"]')) : null);
    if (priceEl) {
      var clone = priceEl.cloneNode(true);
      clone.querySelectorAll('.price-item__label, .visually-hidden, .sr-only, [class*="visually"]').forEach(function(n) { n.remove(); });
      if (priceEl.classList.contains('price--on-sale')) {
        clone.querySelectorAll('.price__regular').forEach(function(n) { n.remove(); });
      } else {
        clone.querySelectorAll('.price__sale').forEach(function(n) { n.remove(); });
      }
      clone.querySelectorAll('.unit-price, .caption').forEach(function(n) { n.remove(); });
      target.innerHTML = clone.innerHTML;
      return;
    }
    var sale = product.price;
    var compare = product.compare_at_price || (product.compare_at_price_min && product.compare_at_price_min > sale ? product.compare_at_price_min : null);
    function fmt(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.?0+$/, ''); }
    var html = '<span>' + fmt(sale) + '</span>';
    if (compare && compare > sale) html += '<s class="qa-sheet__price-compare">' + fmt(compare) + '</s>';
    target.innerHTML = html;
  }

  /* Rivo init trigger — debounced 50ms */
  var _rivoInitPending = null;
  function triggerRivoInit() {
    if (_rivoInitPending) return;
    _rivoInitPending = setTimeout(function () {
      _rivoInitPending = null;
      try {
        var rivoRoot = document.getElementById('rivo-account-slideout');
        if (window.RivoProfileAlpine && rivoRoot) {
          window.RivoProfileAlpine.$data(rivoRoot).initializeFavoriteButtons();
        }
      } catch (e) {}
    }, 50);
  }

  /* Build a Rivo-backed heart button */
  function buildRivoHeart(productId, styleClass, product) {
    var wrapper = document.createElement('span');
    wrapper.className = styleClass + ' favorite-button-wrapper';
    wrapper.setAttribute('role', 'button');
    wrapper.setAttribute('tabindex', '0');
    wrapper.setAttribute('aria-label', 'Add to favorites');
    if (product) {
      try {
        wrapper.setAttribute('data-qa-product', JSON.stringify(rivoProductPayload(product)));
      } catch (e) {}
    }
    var rivo = document.createElement('rivo-favorite-button');
    rivo.setAttribute('data-product-id', String(productId || ''));
    rivo.setAttribute('role', 'button');
    rivo.setAttribute('tabindex', '0');
    rivo.setAttribute('aria-label', 'Add to favorites');
    rivo.innerHTML = HEART_SVG;
    wrapper.appendChild(rivo);
    triggerRivoInit();
    return wrapper;
  }

  var HEART_SVG = '<svg viewBox="0 0 24 24" fill="none"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function rivoProductPayload(p) {
    if (!p) return null;
    return {
      id: p.id,
      price: p.price,
      handle: p.handle,
      tags: p.tags || [],
      available: p.available,
      title: p.title,
      variants: p.variants || []
    };
  }

  /* Capture-phase click — hydrates window.Rivo.common.product before Rivo reads it */
  document.addEventListener('click', function(e) {
    var wrapper = e.target.closest('.favorite-button-wrapper');
    if (!wrapper) return;
    var raw = wrapper.getAttribute('data-qa-product');
    if (!raw) return;
    try {
      var data = JSON.parse(raw);
      window.Rivo = window.Rivo || {};
      window.Rivo.common = window.Rivo.common || {};
      window.Rivo.common.product = data;
    } catch (err) {}
  }, true);

  /* Swap card "+" to ✓ after add-to-cart */
  function markCardAdded(gi) {
    if (!gi) return;
    var plus = gi.querySelector('.qa-mob-wrap .qa-mob[aria-label="Quick add to cart"]');
    if (!plus || plus.classList.contains('qa-mob--added')) return;
    plus.classList.add('qa-mob--added');
    plus.innerHTML = '<svg viewBox="0 0 18 17" fill="none"><path d="M2 8.5L7 14L16 2" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    /* v8: localePath so fallback cart link stays in active locale */
    var btn = document.querySelector('.header__icon--cart') || document.querySelector('[href="' + localePath('/cart') + '"]');
    if (btn) setTimeout(function() { btn.click(); }, 100);
  }

  /* ===== DESKTOP OVERLAY ===== */
  function buildOverlay(cardInner, product, sizes, gi) {
    var container = findVisibleCardMedia(cardInner) || cardInner;
    container.querySelectorAll('[data-qa]').forEach(function(el) { el.remove(); });
    cardInner.querySelectorAll('.qa-mob-wrap').forEach(function(el) { el.remove(); });

    if (!IS_MOBILE) {
      var ov = document.createElement('div');
      ov.className = 'qa-overlay'; ov.setAttribute('data-qa', '1');
      ov.addEventListener('click', function(e) {
        if (e.target.closest('.favorite-button-wrapper, rivo-favorite-button')) return;
        e.stopPropagation();
      });

      var ovState = { selectedSize: null, selectedVariantId: null, selectedColor: null };

      /* Header */
      var header = document.createElement('div');
      header.className = 'qa-overlay__header';
      var label = document.createElement('span');
      label.className = 'qa-overlay__label'; label.textContent = 'Select Size and Color';
      var closeBtn = document.createElement('button');
      closeBtn.className = 'qa-overlay__close'; closeBtn.type = 'button';
      closeBtn.setAttribute('aria-label', 'Close');
      closeBtn.innerHTML = '<svg viewBox="0 0 12 12" fill="none"><line x1="1" y1="1" x2="11" y2="11" stroke="#000" stroke-width="1.5" stroke-linecap="round"/><line x1="11" y1="1" x2="1" y2="11" stroke="#000" stroke-width="1.5" stroke-linecap="round"/></svg>';
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation();
        ov.style.transform = 'translateY(100%)'; ov.style.pointerEvents = 'none';
        cardInner.classList.remove('qa-overlay-open');
        var mobWrap = cardInner.querySelector('.qa-mob-wrap');
        if (mobWrap) mobWrap.style.display = '';
      });
      header.appendChild(label);
      header.appendChild(closeBtn);
      ov.appendChild(header);

      var sep = document.createElement('div');
      sep.className = 'qa-overlay__sep';
      ov.appendChild(sep);

      /* Color swatches */
      var colorInfo = getActiveColor(gi);
      var allColors = getProductColors(product, gi || sheetState.gi);
      if ((allColors && allColors.length > 0) || colorInfo) {
        var clabel = document.createElement('div');
        clabel.className = 'qa-overlay__clabel';
        clabel.textContent = colorInfo ? ('Color: ' + colorInfo.name) : 'Color';
        ov.appendChild(clabel);

        var colorsRow = document.createElement('div');
        colorsRow.className = 'qa-overlay__colors';
        var pcDiv = document.createElement('div');
        pcDiv.className = 'product-colors product-colors-links';
        var colorList = allColors && allColors.length > 0 ? allColors : (colorInfo ? [colorInfo] : []);
        colorList.forEach(function(c) {
          var colorLabel = document.createElement('label');
          colorLabel.className = 'color';
          colorLabel.setAttribute('data-color', c.dataColor || (c.name || '').toLowerCase().replace(/\s+/g, '-'));
          colorLabel.setAttribute('data-color-not-handlized', c.name);
          var swatch = document.createElement('a');
          swatch.className = 'color-swatch';
          swatch.href = 'javascript:void(0)';
          if (c.bg) swatch.style.backgroundColor = c.bg;
          colorLabel.appendChild(swatch);
          if (colorInfo && c.name === colorInfo.name) {
            colorLabel.setAttribute('active', '');
            ovState.selectedColor = c;
          }
          colorLabel.addEventListener('click', function(e) {
            e.preventDefault(); e.stopPropagation();
            pcDiv.querySelectorAll('label.color').forEach(function(d) { d.removeAttribute('active'); });
            colorLabel.setAttribute('active', '');
            ovState.selectedColor = c;
            ovState.selectedSize = null;
            ovState.selectedVariantId = null;
            clabel.textContent = 'Color: ' + c.name;
            cta.textContent = 'Select Size';
            cta.classList.remove('qa-overlay__cta--ready');

            var handle = c.handle;
            if (handle) {
              fetchProduct(handle).then(function(newProduct) {
                if (!newProduct) return;
                var newSizes = getSizes(newProduct) || [];
                row.innerHTML = '';
                newSizes.forEach(function(s) {
                  var b = document.createElement('button');
                  b.className = 'qa-overlay__btn' + (s.avail ? '' : ' qa-overlay__btn--oos');
                  b.textContent = s.label; b.type = 'button';
                  b.setAttribute('data-size-label', s.label);
                  if (s.avail) {
                    b.addEventListener('click', function(ev) {
                      ev.preventDefault(); ev.stopPropagation();
                      row.querySelectorAll('.qa-overlay__btn').forEach(function(btn) { btn.classList.remove('qa-overlay__btn--active'); });
                      b.classList.add('qa-overlay__btn--active');
                      ovState.selectedSize = s.label;
                      ovState.selectedVariantId = s.id;
                      cta.textContent = 'Add to bag';
                      cta.classList.add('qa-overlay__cta--ready');
                    });
                  }
                  row.appendChild(b);
                });

                /* v8 FIX: Rebuild overlay heart when colour changes.
                   v7 only did this in the sheet; the overlay heart stayed
                   pointing at the original product on colour switch. */
                var existingHeart = ov.querySelector('.qa-overlay__heart.favorite-button-wrapper');
                if (existingHeart) {
                  var newOvHeart = buildRivoHeart(newProduct.id, 'qa-overlay__heart', newProduct);
                  existingHeart.parentNode.replaceChild(newOvHeart, existingHeart);
                }
              });
            }
          });
          pcDiv.appendChild(colorLabel);
        });
        colorsRow.appendChild(pcDiv);
        ov.appendChild(colorsRow);
      }

      /* Size label */
      var slabel = document.createElement('div');
      slabel.className = 'qa-overlay__slabel'; slabel.textContent = 'Size';
      ov.appendChild(slabel);

      /* Size pills */
      var row = document.createElement('div');
      row.className = 'qa-overlay__row'; row.setAttribute('data-qa', 'row');
      sizes.forEach(function(s) {
        var b = document.createElement('button');
        b.className = 'qa-overlay__btn' + (s.avail ? '' : ' qa-overlay__btn--oos');
        b.textContent = s.label; b.type = 'button';
        if (s.avail) {
          b.addEventListener('click', function(e) {
            e.preventDefault(); e.stopPropagation();
            row.querySelectorAll('.qa-overlay__btn').forEach(function(btn) { btn.classList.remove('qa-overlay__btn--active'); });
            b.classList.add('qa-overlay__btn--active');
            ovState.selectedSize = s.label;
            ovState.selectedVariantId = s.id;
            cta.textContent = 'Add to bag';
            cta.classList.add('qa-overlay__cta--ready');
          });
        }
        row.appendChild(b);
      });
      ov.appendChild(row);

      /* Actions: CTA + Heart */
      var actions = document.createElement('div');
      actions.className = 'qa-overlay__actions';
      var cta = document.createElement('button');
      cta.className = 'qa-overlay__cta'; cta.type = 'button';
      cta.textContent = 'Select Size';
      cta.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation();
        if (!ovState.selectedVariantId) return;
        cta.textContent = 'Adding to cart';
        cta.style.pointerEvents = 'none';
        addToCart(ovState.selectedVariantId).then(function(ok) {
          if (ok) {
            markCardAdded(gi);
            ov.style.transform = 'translateY(100%)'; ov.style.pointerEvents = 'none';
            cardInner.classList.remove('qa-overlay-open');
            var mobWrap = cardInner.querySelector('.qa-mob-wrap');
            if (mobWrap) mobWrap.style.display = '';
            openCartDrawer();
            setTimeout(function() {
              ovState.selectedSize = null; ovState.selectedVariantId = null;
              cta.textContent = 'Select Size';
              cta.classList.remove('qa-overlay__cta--ready');
              cta.style.pointerEvents = '';
              row.querySelectorAll('.qa-overlay__btn--added, .qa-overlay__btn--active').forEach(function(btn) {
                var lbl = btn.getAttribute('data-size-label') || btn.textContent;
                btn.className = 'qa-overlay__btn';
                btn.textContent = lbl;
              });
            }, 300);
          } else {
            cta.textContent = 'Error — try again';
            cta.style.pointerEvents = '';
            setTimeout(function() {
              cta.textContent = ovState.selectedSize ? 'Add to bag' : 'Select Size';
            }, 1500);
          }
        });
      });
      row.querySelectorAll('.qa-overlay__btn').forEach(function(btn) {
        btn.setAttribute('data-size-label', btn.textContent);
      });

      var heart = buildRivoHeart(product.id, 'qa-overlay__heart', product);
      actions.appendChild(cta);
      actions.appendChild(heart);
      ov.appendChild(actions);

      var status = document.createElement('div');
      status.className = 'qa-overlay__status';
      ov.appendChild(status);

      container.appendChild(ov);
    }

    /* Swatch listener */
    if (gi) {
      var sc = gi.querySelector('color-swatches');
      if (sc && !sc._qaListener) {
        sc._qaListener = true;
        sc.addEventListener('change', function() {
          setTimeout(function() {
            var nh = getActiveHandle(gi);
            if (!nh) return;
            cardInner.removeAttribute('data-qa-handle');
            processGridItem(gi);
          }, 250);
        });
      }
    }

    /* v8 FIX: card image click uses localePath so desktop navigation
       stays in the active locale (/de/, /fr/) instead of stripping it. */
    if (!IS_MOBILE && !cardInner._qaImgClick) {
      cardInner._qaImgClick = true;
      var imgContainer = findVisibleCardMedia(cardInner);
      if (imgContainer) {
        imgContainer.style.cursor = 'pointer';
        imgContainer.addEventListener('click', function(e) {
          if (e.target.closest('.qa-overlay, .qa-mob-wrap, .qa-arrow, .qa-dots')) return;
          if (e.target.closest('a')) return;
          var h = getActiveHandle(gi);
          if (h) window.location.href = localePath('/products/' + h);
        });
      }
    }

    /* Heart + Plus buttons */
    if (!cardInner.querySelector('.qa-mob-wrap')) {
      var wrap = document.createElement('div');
      wrap.className = 'qa-mob-wrap';

      var heartBtn = buildRivoHeart(product.id, 'qa-mob', product);

      var plusBtn = document.createElement('button');
      plusBtn.className = 'qa-mob'; plusBtn.type = 'button';
      plusBtn.setAttribute('aria-label', 'Quick add to cart');
      plusBtn.innerHTML = '<svg viewBox="0 0 20 20" fill="none"><path d="M10 4v12M4 10h12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
      plusBtn.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        var h = getActiveHandle(gi);
        if (!h) return;
        fetchProduct(h).then(function(p) {
          if (!p) return;
          var s = getSizes(p);
          if (!s) return;
          if (IS_MOBILE) {
            openSheet(p, s, getActiveColor(gi), gi);
          } else {
            document.querySelectorAll('.qa-overlay').forEach(function(other) {
              if (other === cardInner.querySelector('.qa-overlay')) return;
              other.style.transform = 'translateY(100%)';
              other.style.pointerEvents = 'none';
              var otherCard = other.closest('.card__inner');
              if (otherCard) otherCard.classList.remove('qa-overlay-open');
              var otherWrap = otherCard && otherCard.querySelector('.qa-mob-wrap');
              if (otherWrap) otherWrap.style.display = '';
            });
            var ov = cardInner.querySelector('.qa-overlay');
            if (ov) { ov.style.transform = 'translateY(0)'; ov.style.pointerEvents = 'auto'; }
            cardInner.classList.add('qa-overlay-open');
            wrap.style.display = 'none';
          }
        });
      });

      wrap.appendChild(heartBtn);
      wrap.appendChild(plusBtn);
      cardInner.appendChild(wrap);
    }
  }

  /* ===== HOVER (desktop) ===== */
  function attachHover(gi) {
    /* Overlay opens via + button only — kept for grid item init. */
  }

  /* ===== MOBILE SHEET ===== */
  var sheetState = { product: null, sizes: null, selectedSize: null, selectedColor: null, selectedVariantId: null, gi: null };

  function openSheet(product, sizes, colorInfo, gi) {
    var sheet = document.getElementById('qaSheet');
    sheetState.product = product;
    sheetState.sizes = sizes;
    sheetState.selectedSize = null;
    sheetState.selectedVariantId = null;
    sheetState.selectedColor = colorInfo;
    sheetState.gi = gi;

    document.getElementById('qaSheetTitle').textContent = 'Select Size and Color';
    document.getElementById('qaSheetStatus').textContent = '';

    /* Product info */
    var imgEl = gi ? gi.querySelector('.card__media img, .media img') : null;
    document.getElementById('qaSheetImg').src = imgEl ? imgEl.src : (product.featured_image || '');
    document.getElementById('qaSheetImg').alt = product.title || '';
    document.getElementById('qaSheetName').textContent = product.title || '';

    /* v8 FIX: build product URL via localePath — product.url from the
       .js endpoint is always locale-stripped (/products/handle). */
    var prodUrl = product.handle ? localePath('/products/' + product.handle) : '#';
    document.getElementById('qaSheetImgLink').href = prodUrl;
    document.getElementById('qaSheetNameLink').href = prodUrl;
    populateSheetPrice(gi, product);

    /* Sheet heart */
    var sheetHeart = document.getElementById('qaSheetHeart');
    sheetHeart.innerHTML = '';
    try { sheetHeart.setAttribute('data-qa-product', JSON.stringify(rivoProductPayload(product))); } catch (e) {}
    if (product && product.id) {
      var rivo = document.createElement('rivo-favorite-button');
      rivo.setAttribute('data-product-id', String(product.id));
      rivo.setAttribute('role', 'button');
      rivo.setAttribute('tabindex', '0');
      rivo.setAttribute('aria-label', 'Add to favorites');
      rivo.innerHTML = HEART_SVG;
      sheetHeart.appendChild(rivo);
      triggerRivoInit();
    }

    /* Color swatches */
    var colorsContainer = document.getElementById('qaSheetColors');
    colorsContainer.innerHTML = '';
    var allColors = getProductColors(product, gi || sheetState.gi);
    if (allColors && allColors.length > 0) {
      document.getElementById('qaSheetClabel').style.display = '';
      var pcDiv = document.createElement('div');
      pcDiv.className = 'product-colors product-colors-links';
      allColors.forEach(function(c) {
        var colorLabel = document.createElement('label');
        colorLabel.className = 'color';
        colorLabel.setAttribute('data-color', c.dataColor || (c.name || '').toLowerCase().replace(/\s+/g, '-'));
        colorLabel.setAttribute('data-color-not-handlized', c.name);
        var swatch = document.createElement('a');
        swatch.className = 'color-swatch';
        swatch.href = 'javascript:void(0)';
        if (c.bg) swatch.style.backgroundColor = c.bg;
        colorLabel.appendChild(swatch);
        if (colorInfo && c.name === colorInfo.name) {
          colorLabel.setAttribute('active', '');
          sheetState.selectedColor = c;
        }
        colorLabel.addEventListener('click', function(e) {
          e.preventDefault();
          pcDiv.querySelectorAll('label.color').forEach(function(d) { d.removeAttribute('active'); });
          colorLabel.setAttribute('active', '');
          selectSheetColor(colorLabel, c);
        });
        pcDiv.appendChild(colorLabel);
      });
      colorsContainer.appendChild(pcDiv);
      updateColorLabel();
    } else if (colorInfo) {
      document.getElementById('qaSheetClabel').style.display = '';
      var pcDiv2 = document.createElement('div');
      pcDiv2.className = 'product-colors product-colors-links';
      var singleLabel = document.createElement('label');
      singleLabel.className = 'color';
      singleLabel.setAttribute('data-color', colorInfo.dataColor || (colorInfo.name || '').toLowerCase().replace(/\s+/g, '-'));
      singleLabel.setAttribute('data-color-not-handlized', colorInfo.name);
      singleLabel.setAttribute('active', '');
      var singleSwatch = document.createElement('a');
      singleSwatch.className = 'color-swatch';
      singleSwatch.href = 'javascript:void(0)';
      if (colorInfo.bg) singleSwatch.style.backgroundColor = colorInfo.bg;
      singleLabel.appendChild(singleSwatch);
      pcDiv2.appendChild(singleLabel);
      colorsContainer.appendChild(pcDiv2);
      updateColorLabel();
    } else {
      document.getElementById('qaSheetClabel').style.display = 'none';
    }

    /* Size pills */
    var container = document.getElementById('qaSheetSizes');
    container.innerHTML = '';
    sizes.forEach(function(s) {
      var btn = document.createElement('button');
      btn.className = 'qa-sheet__btn' + (s.avail ? '' : ' qa-sheet__btn--oos');
      btn.textContent = s.label; btn.type = 'button';
      btn.setAttribute('data-size-label', s.label);
      btn.setAttribute('data-variant-id', s.id);
      if (s.avail) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          selectSheetSize(btn, s);
        });
      }
      container.appendChild(btn);
    });

    updateSheetCta();

    document.getElementById('qaSheetBg').classList.add('qa-sheet-bg--open');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('qa-sheet-lock');
    sheet.style.display = 'block';
    requestAnimationFrame(function() { requestAnimationFrame(function() { sheet.classList.add('qa-sheet--open'); }); });
  }

  function getSiblingCardHTML(gi, targetHandle) {
    if (!gi || !targetHandle) return null;
    var result = null;
    gi.querySelectorAll('color-swatches script[type="application/json"]').forEach(function(s) {
      if (result) return;
      try {
        var data = JSON.parse(s.textContent);
        if (!Array.isArray(data)) return;
        data.forEach(function(e) {
          if (result) return;
          var m = /data-handle="([^"]+)"/.exec(e && e.html ? e.html : '');
          if (m && m[1] === targetHandle) result = e.html;
        });
      } catch (err) {}
    });
    return result;
  }

  function getAllSiblingHandles(gi) {
    if (!gi) return [];
    var out = [], seen = {};
    gi.querySelectorAll('color-swatches script[type="application/json"]').forEach(function(s) {
      try {
        var data = JSON.parse(s.textContent);
        if (!Array.isArray(data)) return;
        data.forEach(function(e) {
          var m = /data-handle="([^"]+)"/.exec(e && e.html ? e.html : '');
          if (m && !seen[m[1]]) { seen[m[1]] = true; out.push(m[1]); }
        });
      } catch (err) {}
    });
    return out;
  }

  function deriveBasePrefix(visibleColors) {
    for (var i = 0; i < visibleColors.length; i++) {
      var v = visibleColors[i];
      if (!v.handle || !v.name) continue;
      var slug = v.name.toLowerCase().replace(/\s+/g, '-');
      var idx = v.handle.lastIndexOf('-' + slug);
      if (idx > 0 && idx === v.handle.length - slug.length - 1) {
        return v.handle.slice(0, idx + 1);
      }
    }
    return null;
  }

  function slugToName(slug) {
    return slug.split('-').map(function(w) {
      return w ? w.charAt(0).toUpperCase() + w.slice(1) : w;
    }).join(' ');
  }

  function getProductColors(product, gi) {
    var colors = [];
    var seen = {};

    if (gi) {
      var inputs = gi.querySelectorAll('color-swatches input[type="radio"]');
      inputs.forEach(function(input) {
        var lbl = document.querySelector('label[for="' + input.id + '"]');
        if (!lbl) return;
        var span = lbl.querySelector('span');
        if (!span) return;
        var bg = window.getComputedStyle(span).backgroundColor;
        var handle = input.getAttribute('data-handle');
        var dc = lbl.getAttribute('data-color') || (input.value || '').toLowerCase().replace(/\s+/g, '-');
        colors.push({ name: input.value, bg: bg, handle: handle, dataColor: dc });
        if (handle) seen[handle] = true;
      });
    }

    var allHandles = getAllSiblingHandles(gi);
    if (allHandles.length) {
      var base = deriveBasePrefix(colors);
      allHandles.forEach(function(handle) {
        if (seen[handle]) return;
        var slug;
        if (base && handle.indexOf(base) === 0) {
          slug = handle.slice(base.length);
        } else {
          var parts = handle.split('-');
          slug = parts.slice(Math.max(parts.length - 2, 0)).join('-');
        }
        colors.push({ name: slugToName(slug), bg: null, handle: handle, dataColor: slug });
        seen[handle] = true;
      });
    }
    if (colors.length) return colors;

    var opts = product.options || [];
    var idx = -1;
    for (var j = 0; j < opts.length; j++) {
      var n = (typeof opts[j] === 'string') ? opts[j] : (opts[j].name || '');
      if (n.toLowerCase() === 'color' || n.toLowerCase() === 'colour') { idx = j; break; }
    }
    if (idx === -1) return null;
    var fallback = [], seenVal = {};
    (product.variants || []).forEach(function(v) {
      var c = v['option' + (idx + 1)];
      if (c && !seenVal[c]) {
        seenVal[c] = true;
        fallback.push({ name: c, bg: colorNameToHex(c), dataColor: c.toLowerCase().replace(/\s+/g, '-') });
      }
    });
    return fallback.length ? fallback : null;
  }

  /* v8 FIX: unknown color names get neutral grey instead of Math.random() hex */
  function colorNameToHex(name) {
    var map = {
      'black':'#000','white':'#fff','red':'#e82525','blue':'#3a5ca8','navy':'#1a2744',
      'green':'#6d716b','grey':'#999','gray':'#999','pink':'#f5c6d0','beige':'#f7f3e8',
      'cream':'#f7f3e8','brown':'#7b6263','olive':'#6d716b','dragon red':'#e82525',
      'petal pink':'#f5c6d0','rose':'#f5c6d0','nude':'#e8c4a8','sand':'#d4c5a9',
      'charcoal':'#3a3a3a','midnight':'#1a1a2e'
    };
    var lower = name.toLowerCase();
    return map[lower] || '#cccccc';
  }

  function selectSheetColor(labelEl, colorData) {
    sheetState.selectedColor = colorData;
    sheetState.selectedSize = null;
    sheetState.selectedVariantId = null;
    updateColorLabel();
    updateSheetCta();

    var handle = colorData.handle;
    if (handle) {
      fetchProduct(handle).then(function(newProduct) {
        if (!newProduct) return;
        sheetState.product = newProduct;
        sheetState.sizes = getSizes(newProduct) || [];

        var opts = newProduct.options || [];
        var colorIdx = -1;
        for (var j = 0; j < opts.length; j++) {
          var on = (typeof opts[j] === 'string') ? opts[j] : (opts[j].name || '');
          if (on.toLowerCase() === 'color' || on.toLowerCase() === 'colour') { colorIdx = j; break; }
        }
        if (colorIdx !== -1 && newProduct.variants && newProduct.variants[0]) {
          var realName = newProduct.variants[0]['option' + (colorIdx + 1)];
          if (realName && colorData.name !== realName) {
            colorData.name = realName;
            labelEl.setAttribute('data-color-not-handlized', realName);
            updateColorLabel();
          }
        }

        document.getElementById('qaSheetName').textContent = newProduct.title || '';
        /* v8 FIX: use localePath for sheet colour-switch URL */
        var newUrl = newProduct.handle ? localePath('/products/' + newProduct.handle) : '#';
        document.getElementById('qaSheetImgLink').href = newUrl;
        document.getElementById('qaSheetNameLink').href = newUrl;

        var siblingHTML = getSiblingCardHTML(sheetState.gi, handle);
        var siblingPriceEl = null;
        if (siblingHTML) {
          var tmp = document.createElement('div');
          tmp.innerHTML = siblingHTML;
          siblingPriceEl = tmp.querySelector('.price');
        }
        populateSheetPrice(sheetState.gi, newProduct, siblingPriceEl);

        var sh = document.getElementById('qaSheetHeart');
        sh.innerHTML = '';
        try { sh.setAttribute('data-qa-product', JSON.stringify(rivoProductPayload(newProduct))); } catch (e) {}
        if (newProduct.id) {
          var rv = document.createElement('rivo-favorite-button');
          rv.setAttribute('data-product-id', String(newProduct.id));
          rv.setAttribute('role', 'button');
          rv.setAttribute('tabindex', '0');
          rv.setAttribute('aria-label', 'Add to favorites');
          rv.innerHTML = HEART_SVG;
          sh.appendChild(rv);
          triggerRivoInit();
        }
        if (newProduct.featured_image) {
          document.getElementById('qaSheetImg').src = newProduct.featured_image;
        }

        rebuildSheetSizes(sheetState.sizes);
      });
    }
  }

  function rebuildSheetSizes(sizes) {
    var container = document.getElementById('qaSheetSizes');
    container.innerHTML = '';
    sizes.forEach(function(s) {
      var btn = document.createElement('button');
      btn.className = 'qa-sheet__btn' + (s.avail ? '' : ' qa-sheet__btn--oos');
      btn.textContent = s.label; btn.type = 'button';
      btn.setAttribute('data-size-label', s.label);
      btn.setAttribute('data-variant-id', s.id);
      if (s.avail) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          selectSheetSize(btn, s);
        });
      }
      container.appendChild(btn);
    });
  }

  function updateColorLabel() {
    var clabel = document.getElementById('qaSheetClabel');
    var activeLabel = document.querySelector('#qaSheetColors label.color[active]');
    if (activeLabel) {
      clabel.textContent = 'Color: ' + activeLabel.getAttribute('data-color-not-handlized');
    }
  }

  function selectSheetSize(btnEl, sizeData) {
    document.querySelectorAll('#qaSheetSizes .qa-sheet__btn').forEach(function(b) {
      b.classList.remove('qa-sheet__btn--active');
    });
    btnEl.classList.add('qa-sheet__btn--active');
    sheetState.selectedSize = sizeData.label;
    sheetState.selectedVariantId = sizeData.id;
    updateSheetCta();
  }

  function updateSheetCta() {
    var cta = document.getElementById('qaSheetCta');
    if (sheetState.selectedSize) {
      cta.textContent = 'Add to bag';
      cta.classList.add('qa-sheet__cta--ready');
      cta.disabled = false;
    } else {
      cta.textContent = 'Select Size';
      cta.classList.remove('qa-sheet__cta--ready');
      cta.disabled = false;
    }
  }

  function handleSheetAddToCart() {
    if (!sheetState.selectedVariantId) return;
    var cta = document.getElementById('qaSheetCta');
    var gi = sheetState.gi;
    cta.textContent = 'Adding to cart';
    cta.style.pointerEvents = 'none';

    addToCart(sheetState.selectedVariantId).then(function(ok) {
      if (ok) {
        if (gi) markCardAdded(gi);
        closeSheet();
        openCartDrawer();
      } else {
        document.getElementById('qaSheetStatus').textContent = 'Error — please try again';
        cta.textContent = 'Add to bag';
        cta.style.pointerEvents = '';
        setTimeout(function() {
          document.getElementById('qaSheetStatus').textContent = '';
        }, 1500);
      }
    });
  }

  document.getElementById('qaSheetCta').addEventListener('click', function(e) {
    e.preventDefault();
    if (sheetState.selectedSize) { handleSheetAddToCart(); }
  });

  function closeSheet() {
    var sheet = document.getElementById('qaSheet');
    sheet.classList.remove('qa-sheet--open');
    document.getElementById('qaSheetBg').classList.remove('qa-sheet-bg--open');
    document.body.style.overflow = '';
    document.body.classList.remove('qa-sheet-lock');
    setTimeout(function() {
      sheet.style.display = 'none';
      var cta = document.getElementById('qaSheetCta');
      cta.style.pointerEvents = '';
    }, 300);
  }

  document.getElementById('qaSheetClose').addEventListener('click', closeSheet);
  document.getElementById('qaSheetBg').addEventListener('click', closeSheet);

  /* ===== PROCESS GRID ITEMS ===== */
  function processGridItem(gi) {
    var ci = gi.querySelector('.card__inner');
    if (!ci) return;
    var handle = getActiveHandle(gi);
    if (!handle) return;
    if (ci.getAttribute('data-qa-handle') === handle) return;
    ci.setAttribute('data-qa-handle', handle);

    fetchProduct(handle).then(function(product) {
      if (!product) return;
      var sizes = getSizes(product);
      if (!sizes) return;
      buildOverlay(ci, product, sizes, gi);
    });
  }

  function scanAll() {
    var gridItems = document.querySelectorAll('.grid__item');
    if (gridItems.length === 0) return;
    document.body.classList.add('qa-active');
    gridItems.forEach(function(gi) {
      attachHover(gi);
      processGridItem(gi);
    });
  }

  function checkStale() {
    document.querySelectorAll('.grid__item').forEach(function(gi) {
      var ci = gi.querySelector('.card__inner');
      if (!ci) return;
      var active = getActiveHandle(gi);
      var current = ci.getAttribute('data-qa-handle');
      if (!active) return;
      if (current !== active) { ci.removeAttribute('data-qa-handle'); processGridItem(gi); return; }
      if (!IS_MOBILE && current && !ci.querySelector('.qa-overlay')) { ci.removeAttribute('data-qa-handle'); processGridItem(gi); }
      if (IS_MOBILE && current && !ci.querySelector('.qa-mob-wrap')) { ci.removeAttribute('data-qa-handle'); processGridItem(gi); }
    });
  }

  /* ===== IMAGE CAROUSEL ===== */
  function findVisibleCardMedia(ci) {
    var result = null;
    ci.querySelectorAll('.card__media').forEach(function(el) {
      if (!result && el.offsetParent) result = el;
    });
    return result || ci.querySelector('.card__media');
  }

  function findMainMedia(ci) {
    var cm = findVisibleCardMedia(ci);
    if (cm) return cm.querySelector('.media') || cm;
    var mediaEls = ci.querySelectorAll('.media');
    for (var i = 0; i < mediaEls.length; i++) {
      if (mediaEls[i].offsetParent) return mediaEls[i];
    }
    return ci.querySelector('.media') || ci.querySelector('.card__media');
  }

  function getProductImages(handle) {
    if (IMG_CACHE[handle]) return Promise.resolve(IMG_CACHE[handle]);
    return fetchProduct(handle).then(function(p) {
      if (!p || !p.images || p.images.length < 2) return null;
      var imgs = p.images.map(function(url) { return url.replace(/(\?|$)/, '?width=800&'); });
      IMG_CACHE[handle] = imgs;
      return imgs;
    });
  }

  function buildCarousel(gi) {
    if (IS_MOBILE) return;

    var ci = gi.querySelector('.card__inner');
    if (!ci) return;
    var handle = getActiveHandle(gi);
    if (!handle) return;

    if (!ci._cs) ci._cs = { idx: 1, images: [], overlayImg: null, dotsEl: null, leftArrow: null, _handle: null };
    var S = ci._cs;

    if (ci._qaCarousel) {
      if (handle !== S._handle) refreshCarousel(gi, ci, S, handle);
      return;
    }
    ci._qaCarousel = true;

    getProductImages(handle).then(function(images) {
      if (!images || images.length < 3) return;
      S.images = images;
      S._handle = handle;
      S.idx = IS_MOBILE ? 0 : 1;

      var mediaDiv = findMainMedia(ci);
      if (!mediaDiv) return;

      var overlayImg = document.createElement('img');
      overlayImg.className = 'qa-carousel-img';
      overlayImg.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;z-index:3;display:none;opacity:1;background:#f4f1ec;';
      mediaDiv.appendChild(overlayImg);
      S.overlayImg = overlayImg;

      images.slice(0, 2).forEach(function(url) { var im = new Image(); im.src = url; });

      var leftArrow = document.createElement('button');
      leftArrow.className = 'qa-arrow qa-arrow--left'; leftArrow.type = 'button';
      leftArrow.setAttribute('data-idx', IS_MOBILE ? '0' : '1');
      leftArrow.innerHTML = '<svg viewBox="0 0 16 16" fill="none"><path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      S.leftArrow = leftArrow;

      var rightArrow = document.createElement('button');
      rightArrow.className = 'qa-arrow qa-arrow--right'; rightArrow.type = 'button';
      rightArrow.innerHTML = '<svg viewBox="0 0 16 16" fill="none"><path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      var dotsEl = document.createElement('div');
      dotsEl.className = 'qa-dots';
      S.dotsEl = dotsEl;
      rebuildDots(S);

      function goTo(newIdx) {
        if (newIdx < 0 || newIdx >= S.images.length) return;
        S.idx = newIdx;
        var oi = S.overlayImg;
        if (!oi || !oi.parentNode) {
          var md = findMainMedia(ci);
          if (!md) return;
          oi = document.createElement('img');
          oi.className = 'qa-carousel-img';
          oi.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;z-index:3;display:none;opacity:1;background:#f4f1ec;';
          md.appendChild(oi);
          S.overlayImg = oi;
        }
        if (IS_MOBILE) {
          if (S.idx === 0) { oi.style.display = 'none'; } else { oi.src = S.images[S.idx]; oi.style.display = 'block'; }
        } else {
          if (S.idx <= 1) { oi.style.display = 'none'; } else { oi.src = S.images[S.idx]; oi.style.display = 'block'; }
        }
        S.leftArrow.setAttribute('data-idx', S.idx);
        var dots = S.dotsEl.querySelectorAll('.qa-dot');
        dots.forEach(function(dot, i) { dot.classList.toggle('qa-dot--active', i === Math.min(S.idx, dots.length - 1)); });
      }

      if (!IS_MOBILE) {
        leftArrow.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); goTo(S.idx - 1); });
        rightArrow.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); goTo(S.idx + 1); });
        ci.appendChild(leftArrow);
        ci.appendChild(rightArrow);
        ci.addEventListener('mouseleave', function() {
          S.idx = 1;
          if (S.overlayImg && S.overlayImg.parentNode) S.overlayImg.style.display = 'none';
          S.leftArrow.setAttribute('data-idx', '1');
          var dots = S.dotsEl.querySelectorAll('.qa-dot');
          dots.forEach(function(dot, i) { dot.classList.toggle('qa-dot--active', i === 1); });
        });
      }

      if (IS_MOBILE) {
        var startX = 0, startY = 0, tracking = false;
        ci.addEventListener('touchstart', function(e) { if (e.touches.length !== 1) return; startX = e.touches[0].clientX; startY = e.touches[0].clientY; tracking = true; }, { passive: true });
        ci.addEventListener('touchmove', function(e) { if (!tracking) return; var dx = e.touches[0].clientX - startX; var dy = e.touches[0].clientY - startY; if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) e.preventDefault(); }, { passive: false });
        ci.addEventListener('touchend', function(e) { if (!tracking) return; tracking = false; var dx = e.changedTouches[0].clientX - startX; if (Math.abs(dx) < 30) return; e.preventDefault(); if (dx < 0) goTo(S.idx + 1); else goTo(S.idx - 1); }, { passive: false });
      }

      ci.appendChild(dotsEl);
      ci._goTo = goTo;

      var sc = gi.querySelector('color-swatches');
      if (sc && !sc._qaCarouselListener) {
        sc._qaCarouselListener = true;
        sc.addEventListener('change', function() { setTimeout(function() { refreshCarousel(gi, ci, S); }, 350); });
      }
    });
  }

  function rebuildDots(S) {
    if (!S.dotsEl) return;
    S.dotsEl.innerHTML = '';
    var maxDots = Math.min(S.images.length, 7);
    for (var d = 0; d < maxDots; d++) {
      var dot = document.createElement('span');
      dot.className = 'qa-dot';
      if (d === S.idx) dot.classList.add('qa-dot--active');
      S.dotsEl.appendChild(dot);
    }
  }

  function refreshCarousel(gi, ci, S, forceHandle) {
    var handle = forceHandle || getActiveHandle(gi);
    if (!handle) return;
    delete IMG_CACHE[handle];
    S.idx = IS_MOBILE ? 0 : 1;
    S._handle = handle;

    if (S.overlayImg && S.overlayImg.parentNode) S.overlayImg.style.display = 'none';

    if (S.leftArrow && !S.leftArrow.parentNode && !IS_MOBILE) {
      ci.appendChild(S.leftArrow);
      var rightArrow = ci.querySelector('.qa-arrow--right');
      if (!rightArrow) {
        var ra = document.createElement('button');
        ra.className = 'qa-arrow qa-arrow--right'; ra.type = 'button';
        ra.innerHTML = '<svg viewBox="0 0 16 16" fill="none"><path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        ra.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); if (ci._goTo) ci._goTo(S.idx + 1); });
        ci.appendChild(ra);
      }
    }
    if (S.leftArrow) S.leftArrow.setAttribute('data-idx', S.idx + '');
    if (S.dotsEl && !S.dotsEl.parentNode) ci.appendChild(S.dotsEl);

    getProductImages(handle).then(function(newImages) {
      if (!newImages || newImages.length < 3) return;
      S.images = newImages;
      rebuildDots(S);
      newImages.slice(0, 2).forEach(function(url) { var im = new Image(); im.src = url; });
      var md = findMainMedia(ci);
      if (md) {
        var existing = md.querySelector('.qa-carousel-img');
        if (!existing) {
          var oi = document.createElement('img');
          oi.className = 'qa-carousel-img';
          oi.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;z-index:3;display:none;opacity:1;background:#f4f1ec;';
          md.appendChild(oi);
          S.overlayImg = oi;
        }
      }
    });
  }

  function scanCarousels() { document.querySelectorAll('.grid__item').forEach(buildCarousel); }

  /* ===== PREFETCH ===== */
  function prefetchSwatchHandles() {
    var handles = {};
    document.querySelectorAll('color-swatches input[type="radio"]').forEach(function(input) {
      var h = input.getAttribute('data-handle');
      if (h && !CACHE[h]) handles[h] = true;
    });
    document.querySelectorAll('.grid__item').forEach(function(gi) {
      getAllSiblingHandles(gi).forEach(function(h) {
        if (h && !CACHE[h]) handles[h] = true;
      });
    });
    var list = Object.keys(handles);
    var i = 0;
    function batch() {
      var chunk = list.slice(i, i + 3);
      if (!chunk.length) return;
      chunk.forEach(function(h) { fetchProduct(h); });
      i += 3;
      setTimeout(batch, 100);
    }
    batch();
  }

  /* ===== BOOT ===== */
  function start() {
    scanAll();
    setTimeout(scanAll, 1500);
    setTimeout(scanAll, 4000);
    setInterval(checkStale, 3000);
  }

  function boot() {
    start();
    setTimeout(scanCarousels, 800);
    setTimeout(scanCarousels, 2500);
    setTimeout(prefetchSwatchHandles, 1200);
    setTimeout(dismissOBLoader, 1500);
  }

  if (document.readyState === 'complete') boot();
  else window.addEventListener('load', boot);

  /* Splash dismissal — bfcache defence */
  function dismissOBLoader() {
    var loader = document.querySelector('.loading-overlay-container');
    if (!loader) return;
    var displayed = (window.getComputedStyle ? window.getComputedStyle(loader).display : loader.style.display) !== 'none';
    if (!displayed) return;
    loader.style.display = 'none';
  }

  /* v8 FIX: clear overflow lock on navigation so bfcache restores don't
     leave the page scroll-locked if the sheet was open when the user left. */
  window.addEventListener('pagehide', function() {
    document.body.style.overflow = '';
    document.body.classList.remove('qa-sheet-lock');
  });

  /* v8 FIX: on bfcache restore, close the sheet before dismissing the loader */
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) { closeSheet(); dismissOBLoader(); return; }
    setTimeout(dismissOBLoader, 1500);
  });

  var target = document.getElementById('ProductGridContainer') || document.getElementById('product-grid') || document.body;
  var debounce;
  new MutationObserver(function() { clearTimeout(debounce); debounce = setTimeout(function() { scanAll(); scanCarousels(); }, 400); }).observe(target, { childList: true, subtree: true });

})();
